<div class="container position-relative">
  @if (hasNavigationContent) {
  <div class="d-flex align-items-center justify-content-between">
    <ng-container *ngTemplateOutlet="navigationLeftContent"></ng-container>
    <app-carousel-navigation
      [swiperInstance]="swiperInstance"
    ></app-carousel-navigation>
  </div>
  } @else {
  <app-carousel-navigation
    [swiperInstance]="swiperInstance"
    class="w-100 mb-4"
  ></app-carousel-navigation>
  }

  <div class="row">
    <div class="col-md-12">
      <swiper-container
        #swiperCardsContainer
        init="false"
        [slides-per-view]="3"
        [speed]="500"
        [loop]="true"
        [navigation]="false"
        [space-between]="10"
        [free-mode]="true"
        class="swiper-3d curved"
        [breakpoints]="breakpoints"
        [swiperInstance]="swiperInstance"
        [items]="upcomingProperties"
        autoplay-delay="2000"
      >
        @for (item of upcomingProperties; track item) {
        <swiper-slide class="swiper-slide-3d pb-4">
          <!-- <app-property-card [hotel]="item"></app-property-card> -->
           <app-upcoming-property-card  [hotel]="item"></app-upcoming-property-card>
        </swiper-slide>
        }
      </swiper-container>
    </div>
  </div>
</div>
